<router-outlet />
<p-toast position="top-right" [breakpoints]="{ '640px': { width: '90vw' } }" />
<p-toast key="clipboard" position="top-right" />
